import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import useCompanyInsight from '../../../hooks/dashboard/companyInsight/useCompanyInsight';
import useCompanyInsightChartData from '../../../hooks/dashboard/companyInsight/useCompanyInsightChartData';
import { COMPANY_INSIGHTS } from '../../../routes/routeConstants';
import CompanyInformation from './CompanyInformation';
import CompanyPerformanceInsights from './CompanyPerformanceInsights';
import DeliveryStatusDistribution from './DeliveryStatusDistribution';
import DisputeResponseInsights from './DisputeResponseInsights';
import LookupHeader from './LookupHeader';

const CompanyInsightSearchResult = () => {
  const { companyName, companyId } = useParams();
  const { pathname } = useLocation();
  const safeCompanyName = companyName ?? '';
  const decodedCompanyName = (() => {
    try {
      return decodeURIComponent(safeCompanyName);
    } catch {
      return safeCompanyName;
    }
  })();
  const { getCompanyInsight, loading, companyInsightData } =
    useCompanyInsight();
  const {
    getCompanyInsightChartData,
    // loading: chartLoading,
    companyInsightChartData,
  } = useCompanyInsightChartData();

  useEffect(() => {
    if (!decodedCompanyName) return;

    getCompanyInsight(companyName, () => {});
    getCompanyInsightChartData(companyId);
    // eslint-disable-next-line
  }, []);

  const pathArr = [
    {
      name: 'Look Up',
      link: `/${COMPANY_INSIGHTS}`,
    },
    {
      name: decodedCompanyName,
      link: pathname,
    },
  ];

  return (
    <Page title='Logirate | Driver History Conflict Details'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <LookupHeader
            isDeleted={companyInsightData?.isDeleted ? 'Deleted' : 'Active'}
            loading={loading}
            companyName={decodedCompanyName}
            status={companyInsightData?.status || ''}
            companyLogoUri={companyInsightData?.profilePicture}
            onboardedOn={companyInsightData?.createdAt || ''}
          />

          <CompanyInformation
            loading={loading}
            roleName={companyInsightData?.accountCreatorRole || ''}
            vehicleTypes={companyInsightData?.fleetCategories || []}
            totalLookupInitiated={companyInsightData?.totalLookupInitiated || 0}
          />

          <DeliveryStatusDistribution
            userExitReason={companyInsightChartData?.exitReasons}
            driverTypeDistribution={
              companyInsightChartData?.workerTypeDistribution
            }
          />

          <DisputeResponseInsights
            incidentReports={companyInsightChartData?.reports}
            hiringConflicts={companyInsightChartData?.conflicts}
            conflictIssues={companyInsightChartData?.conflictIssues}
          />

          <CompanyPerformanceInsights
            performanceTierData={
              companyInsightChartData?.performanceTimeline || []
            }
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default CompanyInsightSearchResult;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
